import axios from 'axios';
import qs from 'qs';
import { getCsrfToken } from '../utils/GeneralUtils';

const ChronusApi = {
  getUrlJS (url, data) {
    return this._requestUrl(url, data, 'get', 'application/javascript').then((response) => {
      // eslint-disable-next-line no-eval
      eval(response.data) // Bad idea. This code is used only for transition purposes. TODO Remove once transistion is finished.
    });
  },

  getUrlJSON (url, data) {
    return this._requestUrl(url, data, 'get', 'application/json').then((response) => {
      return response.data;
    });
  },

  postUrlJS(url, data, headers = {}) {
    return this._requestUrl(url, data, 'post', 'application/javascript', headers).then((response) => {
      // eslint-disable-next-line no-eval
      eval(response.data); // Bad idea. This code is used only for transition purposes. TODO Remove once transistion is finished.
    });
  },

  postUrlJSON(url, data) {
    return this._requestUrl(url, data, 'post', 'application/json');
  },

  patchUrlJS(url, data, headers = {}) {
    return this._requestUrl(url, data, 'patch', 'application/javascript', headers).then((response) => {
      // eslint-disable-next-line no-eval
      eval(response.data); // Bad idea. This code is used only for transition purposes. TODO Remove once transistion is finished.
    });
  },

  patchUrlJSON(url, data) {
    return this._requestUrl(url, data, 'patch', 'application/json');
  },

  deleteUrlJS(url, data) {
    return this._requestUrl(url, data, 'delete', 'application/javascript');
  },

  deleteUrlJSON(url, data) {
    return this._requestUrl(url, data, 'delete', 'application/json');
  },

  getUrlCSV(url, data) {
    return this._requestUrl(url, data, 'get', 'text/csv').then((response) => {
      this._downloadCSV(response);
    });
  },

  _downloadCSV(response) {
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    const fileName = this._getFileNameFromResponse(response) || 'export.csv';

    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  _getFileNameFromResponse(response) {
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      const matches = /filename="([^"]*)"/.exec(contentDisposition);
      if (matches !== null && matches[1]) {
        return matches[1];
      }
    }
    return null;
  },

  _requestUrl(url, data, method, accept, headers = {}) {
    let randomCode = Math.floor(Math.random() * Math.floor(2000)).toString();
    let paramObj = this._getDefaultParams (url, method, accept, randomCode, headers);
    if(method.toLowerCase() === 'get') {
      paramObj = {
        ...paramObj,
        ...{
          params: this._getDataJSON(data),
          paramsSerializer: this._serialize
        }
      }
    }
    else {
      paramObj = {
        ...paramObj,
        ...{
          data: this._getDataJSON(data)
        }
      }
    }
    return axios(paramObj).then((data) => {
      if(!!document.getElementById(randomCode)) {
        document.getElementById(randomCode).remove();
      }
      return data;
    })
  },

  _getDefaultParams (url, method, accept, randomCode, headers = {}) {
    return {
      url: url,
      method: method,
      onDownloadProgress: (progressEvent) => {
        this._progressHandler(randomCode)
      },
      onUploadProgress: (progressEvent) => {
        this._progressHandler(randomCode)
      },

      headers: Object.assign({
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': accept,
        'Accept': accept,
        'X-CSRF-Token': getCsrfToken()
      }, headers)
    }
  },

  _serialize (params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets'
    })
  },

  _getDataJSON (data) {
    if(Object.prototype.toString.call(data) === '[object String]')
      return this._convertDataToJSON(data);
    return data;
  },

  _convertDataToJSON (data) {
    let paramEntries = new URLSearchParams(data).entries();
    let result = {}
    for(let entry of paramEntries) {
      const [key, value] = entry;
      result[key] = value;
    }
    return result;
  },

  _progressHandler (randomCode) {
    if(!document.getElementById(randomCode)) {
      let newdiv = document.createElement("div");
      newdiv.id = randomCode
      newdiv.classList = "ccu-request-in-progress hide"
      newdiv.appendChild(document.createTextNode(""));
      document.body.appendChild(newdiv);
    }
  }
}

export default ChronusApi;
